import { createStyles, makeStyles } from '@material-ui/core';
import { colorVariables } from '../../../../styles/colorVariables';

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      '&.MuiAlert-root': {
        marginBottom: 20,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: colorVariables.red20,
        color: theme.palette.text.primary,
        alignItems: 'center',
        padding: theme.spacing(1, 2),
      },
      '& .MuiAlert-icon': {
         padding: 0,
         marginRight: theme.spacing(1.5),
         alignSelf: 'center',
      },
      '& .MuiAlert-message': {
         flexGrow: 1,
         padding: theme.spacing(0.5, 0),
      },
      '& .MuiAlert-action': {
          marginRight: 0,
          paddingLeft: theme.spacing(2),
          alignSelf: 'center',
      }
    },
    avatar: {
      backgroundColor: colorVariables.red80,
      color: '#fff',
      width: theme.spacing(5),
      height: theme.spacing(5),
    },
    title: {
      fontWeight: 700,
      fontSize: 14,
      color: colorVariables.navy,
    },
    description: {
      fontWeight: 400,
      fontSize: 14,
      color: colorVariables.navy,
    },
    upgradeButton: {
      backgroundColor: colorVariables.red80,
      color: '#fff',
      borderRadius: '20px',
      textTransform: 'none',
      padding: theme.spacing(0.8, 2.5),
      '&:hover': {
        backgroundColor: colorVariables.red80,
      },
    },
  }),
);
